import { createContext, type ReactElement, useState } from 'react';

export type FieldValueType = string | number | boolean;

type FormContextProviderProps = {
  children: ReactElement;
};

export type FormValuesType = {
  [key: string]: FieldValueType;
};

const FormContext = createContext({
  formValues: {} as FormValuesType,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
  setFieldValue: (fieldName: string, fieldValue: FieldValueType) => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  resetFormValues: () => {},
});

const FormContextProvider = ({ children }: FormContextProviderProps) => {
  const defaultValues = {
    deliveryMethod: '',
  };

  const [formValues, setFormValues] = useState<FormValuesType>(defaultValues);

  const setFieldValue = (
    fieldName: string,
    fieldValue: FieldValueType,
  ): void => {
    setFormValues(prev => {
      return {
        ...prev,
        [fieldName]: fieldValue,
      };
    });
  };

  const resetFormValues = (): void => {
    setFormValues(defaultValues);
  };

  return (
    <FormContext.Provider
      value={{
        formValues,
        setFieldValue,
        resetFormValues,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export { FormContext, FormContextProvider };
